module.exports = __webpack_public_path__ + "static/media/card1.bbb6703f.svg";